import PortalLogin from './components/PortalLogin';
import useSEO from '@/hooks/useSEO';

export default function PortalPage() {
  useSEO({
    title: 'Owner Portal | Higher Standard Global',
    description: 'Secure owner portal for Higher Standard Global clients.',
    canonical: '/portal',
    noIndex: true,
  });

  return <PortalLogin />;
}
